






















































import { Component, Emit, Prop, Watch } from "vue-property-decorator";
import Vue from "vue";
import DotCounter from "@/components/weighting/DotCounter.vue";
import { getModule } from "vuex-module-decorators";
import WorkspaceOptions from "@/store/modules/WorkspaceOptions";
import Viewpoints from "@/store/modules/Viewpoints";
import Users from "@/store/modules/Users";
import { FactorGroup } from "@/api/model/FactorResource";
import Modelling from "@/store/modules/Modelling";
import Weighting from "@/store/modules/Weighting";
import { watch } from "fs";

const workspaceOptionsModule = getModule(WorkspaceOptions)
const viewpointsModule = getModule(Viewpoints)
const usersModule = getModule(Users);
const modellingModule = getModule(Modelling)
const weightingModule = getModule(Weighting);

@Component({
    components: {DotCounter}
})
export default class TableSingleWeightInput extends Vue {

    @Prop()
    actionType!: string;

    @Prop()
    tableFactorGroup!: FactorGroup;

    @Prop()
    totalDots!: number;

    private selectedFactorId: string | null = null;
   // private selectedFactorId: string = '';

    get columnWidth() {
        return workspaceOptionsModule.choiceColumnWidth;
    }

    get currentUserId() {
        return usersModule.currentUserProfile.userId
    }

    get factors() {
        return modellingModule.publishedModelFactorResources;
    }

    get selectedViewpoints() {
        return viewpointsModule.selectedViewpoints;
    }

    get viewpointsWeightingDotsMap() {
        return weightingModule.viewpointGroupDots;
    }
 /*
    get tableGroupChildrenId() {
        let factorResourceId = [];
        for ( let resourceId of this.tableFactorGroup.childrenIds) {
            if (this.selectedFactorId === resourceId) {
            return [];
            } else {
                factorResourceId.push(this.factors[resourceId]);
            }
        }
       // if (factorResourceId.length>0){
       //     this.selectedFactorId = factorResourceId[0];
       // }
        return factorResourceId;
    }
 */
    get tableGroupChildrenId() {
        let tableGroupChildrenId = [];
        for (let childrenId of this.tableFactorGroup.childrenIds) {
            tableGroupChildrenId.push(this.factors[childrenId]);
        }
        if (tableGroupChildrenId.length > 0) {
            this.selectedFactorId = tableGroupChildrenId[0];
        }
        return tableGroupChildrenId;
    }

    private async changeParentsDots(viewpointId: string, factorResourceId: any, newValue: number) {
        console.log(newValue);
        await weightingModule.updateViewpointWeightsWithoutSubmit({
            viewpointId: viewpointId,
            factors: {[factorResourceId]: newValue}
        })

        this.dotsChanged(viewpointId);

    }

    @Emit('dots-changed')
    private dotsChanged(viewpointId: string) {
        return viewpointId
    }

}
